<template>
  <div>
    <b-container fluid class="login-box">
      <b-row align-h="center" no-gutters>
        <b-col cols="12" xl="4" class="d-none d-xl-block arm">
          <img :src="flag" class="d-none d-lg-block" />
        </b-col>
        <b-col cols="10" xl="5" class="form" align-h="center">
          <p class="title">Acesso Restrito</p>
          <sp-form @onSubmit="submitLogin" @onReset="onReset">
            <sp-form-cpfcnpj mode="CPF" required v-model="form.username" size />

            <sp-form-input
              label="Senha *"
              type="password"
              v-model="form.password"
              rules="required"
              size
              login-password
            />

            <b-row no-gutters class="mt-3 mb-3">
              <b-col cols="4" xl="5">
                <div style="margin-top: 8px" class="text-center">
                  <sp-captcha ref="captcha" />
                </div>
              </b-col>
              <b-col cols="8" xl="7">
                <sp-form-input
                  label="Insira o código da imagem ao lado *"
                  v-model="form.captcha"
                  rules="required"
                  size
                />
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col class="text-center">
                <sp-button type="reset" :action="onReset" variant="secondary" class="w-90 b">
                  <i class="fas fa-trash"></i> Limpar
                </sp-button>
              </b-col>
              <b-col class="text-center">
                <sp-button
                  type="submit"
                  variant="primary"
                  class="w-90 b"
                  :loading="loadingSignIn"
                  login-submit
                >
                  <i class="fas fa-sign-in-alt"></i> Entrar
                </sp-button>
              </b-col>
            </b-row>

            <b-row no-gutters class="mt-3">
              <b-col class="text-center">
                <sp-button
                  variant="outline-info"
                  @click="$refs.rescuePassword.show()"
                  class="w-90 b"
                  style="font-size: 10px"
                  >Resgatar senha</sp-button
                >
              </b-col>
              <b-col class="text-center">
                <sp-button
                  variant="outline-info"
                  @click="$refs.firstAccess.show()"
                  class="w-90 b"
                  style="font-size: 10px"
                  >Primeiro Acesso
                </sp-button>
              </b-col>
            </b-row>
            <RescuePassword ref="rescuePassword" @submit="submitRescuePassword" />
            <FirstAccess ref="firstAccess" :city="cityName" @submit="submitFirstAccess" />
          </sp-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { cityFlag } from 'sapitur-toolkit-vue';
import RescuePassword from '@/components/login/RescuePassword.vue';
import FirstAccess from '@/components/login/FirstAccess.vue';

import { loginService, userService } from '@/services';

export default {
  components: { RescuePassword, FirstAccess },
  data() {
    return {
      form: loginService.getBlankForm(),
      loadingSignIn: false,
    };
  },
  computed: {
    flag() {
      return cityFlag(this.$store.getters.getCity.id);
    },
    cityName() {
      return this.$store.getters.getCity.nome;
    },
  },
  methods: {
    async submitLogin() {
      this.loadingSignIn = true;
      try {
        loginService.formValidation(this.form, this.$refs.captcha);
        const tokens = await loginService.authenticate(this.form);
        this.$store.commit('SET_TOKENS', tokens);

        const user = await userService.me();
        this.$store.commit('SET_LOGGED', user);
        this.$router.push('/home');
      } catch (error) {
        if (error === 'Bad credentials') this.$alertify.error('Credenciais inválidas');
        else this.$alertify.error(error.message);
      } finally {
        this.loadingSignIn = false;
      }
    },
    onReset() {
      this.form = loginService.getBlankForm();
    },
    async submitFirstAccess(form, setLoading, closeModal) {
      setLoading(true);
      try {
        await loginService.firstAccess(form);
        this.$alertify.success('Senha cadastrada. Por favor, realize o login');
        closeModal();
      } catch (e) {
        this.$alertify.error('Servidor não encontrado');
      } finally {
        setLoading(false);
      }
    },
    async submitRescuePassword(form, setLoading, closeModal) {
      setLoading(true);
      try {
        await loginService.firstAccess(form);
        this.$alertify.success('Senha alterada. Por favor, realize o login');
        closeModal();
      } catch (e) {
        this.$alertify.error('Erro ao resgatar a senha');
      } finally {
        setLoading(false);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/imports.scss';

.login-box {
  padding-top: 70px !important;

  @include media-breakpoint-up(xl) {
    padding-top: 170px !important;
  }

  .arm {
    display: flex !important;
    align-items: center;
    justify-content: center;
    height: inherit;
    text-align: center;

    img {
      width: 200px;
      height: 200px;
      min-width: 200px;
      min-height: 200px;

      @include media-breakpoint-up(xl) {
        width: 250px;
        height: 250px;
        min-width: 250px;
        min-height: 250px;
      }
    }
  }

  .form {
    margin-top: 15px;
    margin-bottom: 30px;

    @include media-breakpoint-up(xl) {
      padding-left: 50px !important;
      border-left: 3px solid black;
      margin-top: 0;
      margin-bottom: 0px;
    }

    .title {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .svg-inline--fa.fa-w-14 {
    width: 0.65rem;
  }
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 80vh;
  font-size: 25px;
}
</style>
